
import Vue, { PropType } from 'vue';
import { RunnitNodeDef, RUNNIT_TYPE, User, Runnit, Avatar } from '@run-diffusion/shared';
import { mapState, mapActions } from 'vuex';
import _shuffle from 'lodash/shuffle';
import { RunnitsCRUDMixin } from '@/mixins';
import RunnitImage from '@/views/Runnits/RunnitImage.vue';
import BaseButton from '@/components/base/BaseButton.vue';
import TrainingVideoPlayer from '@/components/TrainingVideoPlayer.vue';

export default Vue.extend({
	name: 'ToolOnboardingTopCard',
	mixins: [
		RunnitsCRUDMixin,
	],
	props: {
		nodeDef: { type: [Object, String] as PropType<RunnitNodeDef | string>, default: null },
		runnit: { type: [Object, String] as PropType<Runnit | string>, default: null },
		drawerOpen: { type: Boolean, default: false },
		isDismissed: { type: Boolean, default: false },
		persistent: { type: Boolean, default: false },
		isDialog: { type: Boolean, default: false },
	},
	data () {
		return {
			numGridItems: 16,
		};
	},
	computed: {
		...mapState([
			'publicRunnitNodeDefs',
			'loadingPublicRunnitNodeDefs',
			'publicRunnitNodeDefTags',
			'user',
		]),
		onboardingData (): {
			id: string,
			title: string,
			description: string,
			descriptionHtml: string,
			articleUrl: string,
			videoUrl: string,
			avatar: Avatar,
			imageUrl: string,
		} | null {
			if (typeof this.nodeDef === 'object' && this.nodeDef !== null) {
				const nodeDef = this.nodeDef as RunnitNodeDef;
				const onboardingData = {
					id: nodeDef.id || nodeDef.title || 'unknown',
					title: nodeDef.title,
					description: nodeDef.description,
					descriptionHtml: nodeDef.onboardingData?.descriptionHtml,
					articleUrl: nodeDef.articleUrl,
					videoUrl: nodeDef.onboardingData?.videoUrl,
					avatar: nodeDef.avatar,
					imageUrl: nodeDef.imageUrl,
				};
				return onboardingData;
			}
			if (typeof this.runnit === 'object' && this.runnit !== null) {
				const runnit = this.runnit as Runnit;
				const onboardingData = {
					id: runnit.id,
					title: runnit.title,
					description: runnit.description,
					descriptionHtml: runnit.onboardingData?.descriptionHtml,
					articleUrl: runnit.onboardingData?.tutorialUrl || null,
					videoUrl: runnit.onboardingData?.videoUrl,
					avatar: runnit.avatar,
					imageUrl: null,
				};
				return onboardingData;
			}
			return null;
		},
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		goToArticle () {
			if (this.onboardingData?.articleUrl) {
				window.open(this.onboardingData.articleUrl, '_blank');
			}
		},
		async toggleOnboardingDismissed (nodeDefId: string) {
			if (this.persistent) return;
			this.$emit('toggle-onboarding-dismissed', nodeDefId);
		},
	},
	components: {
		BaseButton,
		TrainingVideoPlayer,
		RunnitImage,
	},
});
